import { forwardRef, useEffect, useState } from 'react'
import { VirtuosoGrid } from 'react-virtuoso'
import { SuccessRunSpyNotification } from '../../presentationals/SuccessRunSpyNotification'
import { SpyLaunchFinishedNotification } from '../../presentationals/SpyLaunchFinishedNotification'
import { TestNotification } from '../../presentationals/TestNotification'
import { PriceWarningNotification } from '../../presentationals/PriceWarningNotification'
import { PropertySpyNotification } from '../../presentationals/PropertySpyNotification'
import { SpyRunError } from '../../presentationals/SpyRunError'
import { useEventListener } from 'shared/providers/EventBusProvider'
import { useReadNotificationListQuery } from 'entities/notifications/api/notificationsApi'
import { useContextLocation } from 'shared/hooks/useContextLocation'
import { ReadNotificationListParams } from 'entities/notifications/api/types'

const gridComponents: any = {
    List: forwardRef(({ style, children, ...props }: any, ref) => (
        <div
            ref={ref}
            {...props}
            style={{
                display: "flex",
                flexWrap: "wrap",
                ...style,
            }}
        >
            {children}
        </div>
    )),

    Item: ({ children, ...props }: any) => (
        <div
            {...props}
            style={{
                display: "flex",
                flex: "none",
                alignContent: "stretch",
                boxSizing: "border-box",
            }}
        >
            {children}
        </div>
    )
}

const ItemWrapper = ({ children, ...props }: any) => (
    <div
        {...props}
        style={{
            margin: '30px'
        }}
    >
        {children}
    </div>
)

export const NotificationListContainer = (): JSX.Element => {
    const {
            selectContextLocation,
            setContextLocation
        } = useContextLocation()

    useEventListener('defaultContextControl:search', (item) => {
        setReadNotificationListQueryParams((prev: ReadNotificationListParams) => {
            const params: ReadNotificationListParams = {
                pagination: {
                    page: 0,
                    pageSize: 100
                },
            }

            if (selectContextLocation !== undefined){
                params['locationId'] =  selectContextLocation.id
            }

            return params
        })
    })

    const [readNotificationListQueryDataFiltered, setReadNotificationListQueryDataFiltered] = useState<any[]>([])
    const [readNotificationListQueryOptions, setReadNotificationListQueryOptions] = useState<any>(
        {
            skip: false
        }
    )

    const [readNotificationListQueryParams, setReadNotificationListQueryParams] = useState<ReadNotificationListParams>(
        {
            pagination: {
                page: 0,
                pageSize: 100
            },
            ...(selectContextLocation!== undefined && {locationId : selectContextLocation.id})
        }
    )

    const {
        data: readNotificationListQueryData,
        isLoading: readNotificationListQueryDataIsLoading,
        isFetching: readNotificationListQueryDataIsFetching
    } = useReadNotificationListQuery(readNotificationListQueryParams,readNotificationListQueryOptions)

    useEffect(() => {
        if (readNotificationListQueryData === undefined) return

        setReadNotificationListQueryDataFiltered(readNotificationListQueryData.list
            .filter((d: any)=> {
                    if (d.data === 'null'){
                        return false
                    }

                    const parsedData = JSON.parse(d.data)
                    if (parsedData.type === 3 && parsedData.MonitorTitle === undefined){
                        return false
                    }
               

                    return true
                })
        )
    }, [readNotificationListQueryData])

    const renderNotification = (notification: any) => {
        const data: any = JSON.parse(notification.data);
        
        switch (data.type) {
            case 0: {
                return (
                    <SuccessRunSpyNotification notificationLog={notification} />
                )
            }
            case 1: {
                return ('Spy error')
            }
            case 2: {
                return (
                    <SpyRunError notificationLog={notification}  />
                )
            }
            case 3: {
                return (
                    <SpyLaunchFinishedNotification notificationLog={notification} />
                )
            }
            case 4: {
                return (<TestNotification notificationLog={notification} />)
            }
            case 5: {
                return (<PriceWarningNotification notificationLog={notification} />)
            }
            case 6: {
                return (
                    <PropertySpyNotification
                        notificationLog={notification}
                    />
                )
            }

            default: {
                return (
                    <>
                        {JSON.stringify(data)}
                    </>
                )

            }
        }
    }

    if (readNotificationListQueryDataIsLoading === true) {
        return <></>
    }

    return (
        <>
            <VirtuosoGrid            
                totalCount={readNotificationListQueryDataFiltered.length || 0}
                components={gridComponents}
                itemContent={
                    (index) => (<ItemWrapper>{renderNotification(readNotificationListQueryDataFiltered[index])}</ItemWrapper>)
                }
            />
        </>
    )
}